export default {
  userInfo: {}, // 用户信息
  userBaseInfo: {}, // 用户基本信息
  address: {}, // 地址信息
  passengerInfo: [], // 我的乘客信息
  patientInfo: {}, // 我的就诊人信息
  allOrder: [], // 总订单
  expressInfo: {}, // 快递信息
  ticketInfo: {}, // 票务信息
  otherInfo: {}, // 其他信息
  orderInfo: {}, // 订单信息
  balancePay: {}, // 余额支付
  amount: {amount: 0}, // 优惠券价格
  addFee: 0, // 加价
  budget: 0, // 预算费
  fee: {serviceFee: 0}, // 同城服务费和夜间服务费
  expressType: 0, // 快递类型
  doctorInfo: [], // 医生信息
  hospitalInfo: {}, // 医院信息
  payType: 1 // 支付方式
}



// WEBPACK FOOTER //
// ./src/store/state.js